<!-- 组织机构详情-->
<template>
  <div class="c-organization-detail">
    <div class="wrapper">
      <!-- <section class="search">
                <DetailSearch />
            </section> -->
      <div class="company-info">
        <div class="left">
          <img v-bind:src="org.logo" alt="">
        </div>
        <div class="right">
          <div class="flex align-center">
            <div class="title">{{org.organization}}</div>
            <div class="rending-img margin-left-sm" v-show="org.certificatenumber"></div>
          </div>

          <div class="info">
            <p>法人代表：<span>{{org.legalperson}}</span></p>
            <p>注册资金：<span>{{org.registeredcapital}}万元</span></p>
            <p>统一信用代码：<span>{{org.scc}}</span></p>
            <p>机构地址：<span>{{org.province}}{{org.district}}{{org.address}}</span></p>
            <p>专业领域：<span>{{org.industrycategory}}{{dfcy}}{{kcpt}}</span></p>
          </div>
          <!-- <span class="attention">关注企业</span> -->
        </div>
      </div>
      <div class="company-info__detail">
        <div class="company-info__detail-title">
          详细信息
        </div>
        <div class="company-info__detail-content">
          <div class="right">
            <p class="desc">
              {{org.orgdesc}}
            </p>
            <!-- <p class="expand">展开</p> -->
          </div>
        </div>
      </div>
      <div class="category-container">
        <div class="category-item">
          <div class="cateroty-title-wrapper">
            <p class="cateroty-title">产品展示</p>
          </div>
          <div class="category-list-product">
            <div v-for="p in productList" :key="p.pid" class="category-list-product-item">
              <div class="cover-container item-top flex justify-center">
                <img class="item-img" @click="gotoDetail('/detail/product?pid='+p.pid)" :src="p.previewImg" alt="">
              </div>
              <div class="item-bottom">
                <!-- <div class="price-contaner">
                                    <span class="price">￥160000</span>
                                    <span class="flag">热评度</span>
                                </div> -->
                <p class="vedio-title">{{p.productname}}</p>
                <div class="company-container">
                  <!-- <span class="company">北京科创技术有限公</span> -->
                  <!-- <span class="btn">查看详情</span> -->
                </div>
              </div>
              <!-- <div class="btn-m">立即咨询</div> -->
            </div>
          </div>
        </div>
        <div class="category-item">
          <div class="cateroty-title-wrapper">
            <p class="cateroty-title">服务能力</p>
          </div>
          <div class="category-list-service">
            <div v-for="s in serviceList" :key="s.sid" class="category-list-item">
              <div class="top">
                <img @click="gotoDetail('/detail/service?sid='+s.sid)" :src="s.previewImg" alt="">
              </div>
              <div class="bottom">
                <p class="title">{{s.serviceName}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="category-item">
          <div class="cateroty-title-wrapper">
            <p class="cateroty-title">成功案例</p>
          </div>
          <div class="category-list-case">
            <div v-for="c in caseList" :key="c.cid" class="category-list-item">
              <div class="top">
                <img @click="gotoDetail('/detail/case?cid='+c.cid)" :src="c.previewImg" alt="">
              </div>
              <div class="bottom">
                <p class="vedio-title">{{c.caseName}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="category-item">
          <div class="cateroty-title-wrapper">
            <p class="cateroty-title">智慧场景</p>
          </div>
          <div class="category-list-video">
            <div v-for="v in videoList" :key="v.vid" class="category-list-item">
              <div class="top">
                <img @click="gotoDetail('/detail/video?vid='+v.vid)" :src="v.previewImg" alt="">
              </div>
              <div class="bottom">
                <div class="vedio-title">{{v.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import copyToClipboard from '@/utils/clipboard';
  import {
    getUserinfo,
    getOrgDetail
  } from '@/api/personalCenter';
  import {
    deleteProduct,
  } from '@/api/product';
  import {
    deleteService,
  } from '@/api/service';
  import {
    deleteCase,
  } from '@/api/case';
  import {
    deleteVideo,
  } from '@/api/video';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import config from '@/config/index';
  import {
    mobilecheck
  } from '@/utils/ua';
  import {
    Popconfirm
  } from 'element-ui';
  import DetailSearch from '@/components/detail/DetailSearch'


  export default {
    name: 'Organization',
    props: {
      msg: String,
    },
    components: {
      [Popconfirm.name]: Popconfirm,
      DetailSearch
    },
    data() {
      return {
        hasData: false,
        productList: [],
        videoList: [],
        serviceList: [],
        caseList: [],
        org: {},
        dfcy: '',
        kcpt: '',
        buyVip: false,
        selectedTab: 'display',
        orgid: ''
      }
    },
    computed: {},
    mounted() {
      this.orgid = this.$route.query.orgid;
      this.queryOrgInfo();
    },
    methods: {
      changeTab(type) {
        this.selectedTab = type;
      },
      gotoOrgCreate() {
        // 移动端提示复制链接
        if (mobilecheck()) {
          this.onOrgCreateM();
          return;
        }
        this.$router.push('/personal-center/org-create');
      },
      formatProduct(list, key) {
        let img = '';
        if (key === 'cover') {
          list.forEach(element => {
            img = element[key]
            element.previewImg = `${config.HOST_IMG}${img}`;
          });
        } else {
          list.forEach(element => {
            img = element[key] && JSON.parse(element[key]);
            element.previewImg = img && `${config.HOST_IMG}${img[0]}`;
          });
        }

        return list;
      },
      queryOrgInfo() {

        this.$http.get(getOrgDetail(this.orgid)).then(res => {
          console.log(res);
          this.org = res.data;
          if (this.org && this.org.checked !== 1) {
            this.$router.push('/personal-center/org-create');
          } else if (this.org.tag && typeof this.org.tag === 'string') {
            const tag = JSON.parse(this.org.tag);
            this.org.logo = `${config.HOST_IMG}${this.org.logo}`
            this.dfcy = tag.dfcy;
            this.kcpt = tag.kcpt;
            this.productList = this.formatProduct(this.org.productList, 'img');
            this.serviceList = this.formatProduct(this.org.serviceList, 'img');
            this.caseList = this.formatProduct(this.org.caseList, 'logo');
            this.videoList = this.formatProduct(this.org.videoList, 'cover');
          }
        });
      },
      onAdd(type) {
        // 移动端提示复制链接
        if (mobilecheck()) {
          this.onOrgCreateM();
          return;
        }
        this.$router.push(`${type}?orgid=${this.org.orgid}`);
      },
      onEdit(type) {
        // 移动端提示复制链接
        if (mobilecheck()) {
          this.onOrgCreateM();
          return;
        }
        this.$router.push(`${type}&orgid=${this.org.orgid}`);
      },
      onOrgCreateM() {
        const link = window.location.origin + '/org-create#/personal-center/org-create';
        copyToClipboard(link).then((res) => {
          if (res.success) {
            this.$message.success('链接已复制，请在 PC 端粘贴并打开进行操作!');
          } else {
            this.$message.error(res.msg);
          }
        }, err => {
          this.$message.error('该浏览器不支持点击复制到剪贴板');
        });
      },
      onProductDel(pid) {
        console.log(pid);
        if (!pid) return;
        this.$http.post(deleteProduct(), {
          pid
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.queryUserInfo();
          }
        });
      },
      onServiceDel(sid) {
        console.log(sid);
        if (!sid) return;
        this.$http.post(deleteService(), {
          sid
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.queryUserInfo();
          }
        });
      },
      onCaseDel(cid) {
        console.log(cid);
        if (!cid) return;
        this.$http.post(deleteCase(), {
          cid
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.queryUserInfo();
          }
        });
      },
      onVideoDel(vid) {
        console.log(vid);
        if (!vid) return;
        this.$http.post(deleteVideo(), {
          vid
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.queryUserInfo();
          }
        });
      },
      gotoDetail(path) {
        this.$router.push(path);
      }
    }
  };
</script>

<style scoped>
  @import url(../../mainui.css);

  .vedio-title {
    height: 18px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .search {
    padding: 16px 0;
  }

  .c-organization-detail {
    background: rgba(249, 249, 249, 1);
    width: 100%;
  }

  .wrapper {
    /* width: 100%; */
    /* max-width: 12rem; */
    width: 12.1rem;
    margin: 0 auto;
  }

  .company-info {
    padding: 30px;
    height: 336px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    display: flex;
  }

  .company-info .left {
    width: 372px;
    height: 278px;
    display: inline-block;
  }

  .company-info .right {
    margin-left: 20px;
    display: inline-flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    vertical-align: top;
    position: relative;
    width: 7.83rem;
  }

  .company-info .right .attention {
    position: absolute;
    bottom: 0;
    right: 0;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
  }

  .company-info .left img {
    width: 100%;
    height: 100%;
  }

  .company-info .right .title {
    height: 42px;
    font-size: .3rem;
    color: rgba(66, 65, 65, 1);
    line-height: 42px;
    padding: 20px 0;
  }

  .company-info .right .info {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }

  .company-info .right .info p {
    height: 20px;
    margin-top: 10px;
  }

  .company-info__detail {
    height: 157px;
    background: rgba(255, 255, 255, 1);
    margin-top: 10px;
    padding: .28rem .48rem;
    box-sizing: border-box;
  }

  .company-info__detail-title,
  .cateroty-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
    border-left: solid 2px #267FF2;
    padding-left: 10px;
    line-height: .17rem;
  }

  .company-info__detail-content {
    display: flex;
    font-size: .14rem;
    margin-top: .14rem;
  }

  .company-info__detail-content .left {
    width: .7rem;
    color: rgba(51, 51, 51, 1);
    flex-shrink: 0;
  }

  .company-info__detail-content .right {
    font-size: .14rem;
    color: rgba(102, 102, 102, 1);
  }

  .company-info__detail-content .right .desc {
    height: .42rem;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;

  }

  .expand {
    margin-top: .06rem;
    color: #267FF2;
    cursor: pointer;
  }

  .category-container {
    background-color: #fff;
    margin-top: .1rem;
    padding-bottom: .8rem;
  }

  .cateroty-title-wrapper {
    padding: .28rem .28rem .17rem .48rem;
    box-sizing: border-box;
  }

  .category-list-product-item {
    width: 2.3rem;
    height: 3.28rem;
    border: 1px solid rgba(217, 217, 217, 1);
    box-sizing: border-box;
    display: inline-block;
  }

  .category-list-product-item:not(:nth-child(5n)) {
    margin-right: .12rem;
  }

  .category-list-product-item:nth-child(6n) {
    margin-top: 10px;
  }

  .category-list-product-item .cover-container {
    height: 2.72rem;
  }

  .category-list-product-item .cover-container img {
    /* width: 100%;
    height: 100%; */
    cursor: pointer;
  }

  .item-img {
    width: 170px;
    height: 170px;
    margin: 30px;
  }

  .category-list-product-item .item-bottom {
    padding: .16rem .14rem .19rem .14rem;
  }

  .category-list-product-item .item-bottom .btn-m {
    display: none;
  }

  .price-contaner {
    display: flex;
    justify-content: space-between;
    line-height: 33px;
  }

  .price-contaner .price {
    font-size: 24px;
    color: rgba(38, 127, 242, 1);
  }

  .price-contaner .flag {
    font-size: 14px;
    color: rgba(208, 2, 27, 1);
  }

  .category-list-product-item .item-bottom .name {
    font-size: 14px;
    color: rgba(103, 102, 102, 1);
    margin-top: .16rem;
  }

  .category-list-product-item .item-bottom .company-container {
    margin-top: .16rem;
    display: flex;
  }

  .company-container .company {
    font-size: 14px;
    color: rgba(103, 102, 102, 1);
    flex-shrink: 0;
  }

  .company-container .btn {
    font-size: 12px;
    color: #267FF2;
    height: 20px;
    border: 1px solid rgba(38, 127, 242, 1);
    margin-left: 10px;
    padding: 2px 8px;
    box-sizing: border-box;
    display: inline-block;
    flex-shrink: 0;
    cursor: pointer;
  }

  .category-list-item {
    border: 1px solid #ccc;
    width: 292px;
    margin-right: .09rem;
    display: inline-block;
    box-sizing: border-box;
  }

  .category-list-item:nth-child(5n) {
    margin-top: 10px;
  }

  .category-list-item .top {
    width: 292px;
    height: 144px;
  }

  .category-list-item .top img {
    width: 100%;
    height: 100%;
  }

  .category-list-item .bottom {
    font-size: 14px;
    color: rgba(128, 128, 128, 1);
    padding: .07rem .12rem;
  }

  .rending-img {
    width: 96px;
    height: 29px;
    background-image: url('../../assets/main/rending.png');
  }

  body.h5Style .wrapper {
    width: 100%;
  }

  body.h5Style .search {
    padding: .16rem;
    background-color: #fff;
  }

  /* body.h5Style .c-detail-search {
        width: 6.68rem;
    } */
  body.h5Style .search-input {
    width: 2.03rem !important;
  }

  body.h5Style .company-info {
    flex-direction: column;
    padding: unset;
  }

  body.h5Style .company-info .left {
    width: 7.5rem;
    height: 5.56rem;
  }

  body.h5Style .company-info .right {
    margin: unset;
    width: 100%;
    padding: 0 .52rem;
    box-sizing: border-box;
    padding-bottom: .52rem;
  }

  body.h5Style .company-info .right .info p {
    margin-top: .2rem;
  }

  body.h5Style .company-info {
    height: auto;
  }

  body.h5Style .company-info .right .attention {
    right: .52rem;
    bottom: .52rem;
  }

  body.h5Style .company-info .right .title {
    font-size: 40px;
  }

  body.h5Style .company-info .right .info {
    font-size: 28px;
  }

  body.h5Style .company-info .right .info p {
    height: .4rem;
  }

  body.h5Style .company-info__detail-title,
  body.h5Style .cateroty-title {
    /* height:52px; */
    font-size: 36px;
    line-height: 36px;
    border-left: solid 4px #267FF2;
  }

  body.h5Style .company-info__detail-content {
    font-size: 28px;
    margin-top: 30px;
  }

  body.h5Style .company-info__detail-content .left {
    display: none;
  }

  body.h5Style .company-info__detail-content .right {
    font-size: 28px;
  }

  body.h5Style .company-info__detail {
    height: auto;
    padding: .28rem .26rem;
  }

  body.h5Style .category-container {
    padding: 0 .26rem .8rem .26rem;
  }

  body.h5Style .cateroty-title-wrapper {
    padding: .72rem 0 .32rem 0;
  }

  body.h5Style .category-list-product-item {
    /* max-width: 3.35rem; */
    width: calc(50% - .2rem);
    height: 6.54rem;
    display: inline-block;
  }

  body.h5Style .category-list-product {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  body.h5Style .category-list-product-item {
    margin-right: unset;
  }

  body.h5Style .category-list-product-item {
    margin-top: .2rem;
  }

  body.h5Style .category-list-product-item .cover-container {
    height: 4rem;
  }

  body.h5Style .price-contaner .price {
    font-size: 36px;
  }

  body.h5Style .price-contaner .flag {
    display: none;
  }

  body.h5Style .category-list-product-item .item-bottom {
    position: relative;
  }

  body.h5Style .category-list-product-item .item-bottom .name {
    overflow: hidden;
    text-overflow: ellipsis;
    height: .36rem;
    white-space: nowrap;
  }

  body.h5Style .category-list-product-item .item-bottom .name,
  body.h5Style .company-container .company {
    font-size: 24px;
  }

  body.h5Style .company-container .btn {
    display: none;
  }

  body.h5Style .category-list-product-item .btn-m {
    display: block;
    height: .66rem;
    line-height: .66rem;
    width: 100%;
    text-align: center;
    left: 0;
    margin-left: 0;
    border: unset;
    border-top: solid 1px #D9D9D9;
    font-size: 24px;
    color: #267FF2;
    cursor: pointer;
  }

  body.h5Style .category-list-item {
    width: 100%;
    margin-right: unset;
    margin-bottom: 10px;
  }

  body.h5Style .category-list-item .top {
    width: 100%;
    height: 3.38rem;
  }

  body.h5Style .category-list-item .bottom {
    height: .98rem;
    line-height: .98rem;
    font-size: 32px;
  }
</style>
